import { ButtonUpsellProtected } from '@components'

import { Color, Flex, IconButton, Link, Spacing, Text, useDrawer } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocalStorage } from 'react-use'

import { ScoutDiscovery } from '../../../../assets/images'
import { LocalStorageKeys } from '../../../../enums/localStorageKeys'
import { Scope } from '../../../../enums/scope'
import { TrackingContext } from '../../../../enums/trackingContext'
import { useUserflow } from '../../../../hooks'
import { USERFLOW_SCOUT_ONBOARDING_ID } from '../../../dashboard/constants/userflowIds'
import { ScoutBannerContentWrapper, ScoutBannerWrapper } from './styles'

export const ScoutBanner = (): ReactElement | null => {
  const { t } = useTranslation()
  const { start } = useUserflow()
  const { open: handleOpenScoutDrawer } = useDrawer()
  const [isScoutBannerClosed, setIsScoutBannerClosed] = useLocalStorage(LocalStorageKeys.ScoutBannerClosed)

  const handleStartScoutOnboardingFlow = useCallback(() => start(USERFLOW_SCOUT_ONBOARDING_ID), [start])
  const handleCloseScoutBanner = useCallback(() => setIsScoutBannerClosed(true), [setIsScoutBannerClosed])

  if (isScoutBannerClosed) {
    return null
  }

  return (
    <ScoutBannerWrapper>
      <ScoutBannerContentWrapper>
        <Flex alignItems="center" gap={Spacing.S24}>
          <ScoutDiscovery />
          <Flex flexDirection="column">
            <Text color={Color.Grey950} variant="h4">
              {t('scout.banner.title')}
            </Text>
            <Text colorVariant="secondary">{t('scout.banner.subtitle')}</Text>
          </Flex>
        </Flex>
        <Flex alignItems="center" gap={Spacing.S12}>
          <Link onClick={handleStartScoutOnboardingFlow}>
            <Text colorVariant="secondary">{t('scout.banner.linkText')}</Text>
          </Link>
          <ButtonUpsellProtected
            color="accent"
            icon="zap"
            onClick={handleOpenScoutDrawer}
            size="md"
            trackingContext={TrackingContext.Scout}
            upsellScope={Scope.ScoutUpsell}
            variant="onColor"
          >
            {t('scout.banner.buttonText')}
          </ButtonUpsellProtected>
          <IconButton size="sm" variant="text" onClick={handleCloseScoutBanner} icon="x" />
        </Flex>
      </ScoutBannerContentWrapper>
    </ScoutBannerWrapper>
  )
}
